import React from "react";
import { Trash2, TrendingUp } from "lucide-react";

function daysLeft(iso) {
  if (!iso) return null;
  return Math.ceil((new Date(iso) - new Date()) / 86400000);
}

export default function UsersTable({ users, loading, onEdit, onDelete }) {
  return (
    <div className="glass rounded-xl border border-slate-800 overflow-hidden">
      <div className="p-4 border-b border-slate-800 flex items-center gap-2 text-slate-300">
        <TrendingUp size={16} /> <span className="font-semibold">Subscribers</span>
      </div>
      {loading ? (
        <div className="p-10 text-center text-slate-400">Loading...</div>
      ) : users.length === 0 ? (
        <div className="p-10 text-center text-slate-400">No users yet. Create your first customer.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase text-slate-400 border-b border-slate-800">
              <tr>
                <th className="text-left p-4">Email</th>
                <th className="text-left p-4">Name</th>
                <th className="text-left p-4">Status</th>
                <th className="text-left p-4">Expiry</th>
                <th className="text-left p-4">Days Left</th>
                <th className="text-right p-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => {
                const dl = daysLeft(u.expiry_date);
                const expired = dl !== null && dl <= 0;
                return (
                  <tr key={u.id} data-testid={`user-row-${u.email}`}
                    className="border-b border-slate-800/60 hover:bg-slate-800/40">
                    <td className="p-4 font-medium">{u.email}</td>
                    <td className="p-4 text-slate-300">{u.name || "-"}</td>
                    <td className="p-4">
                      {!u.is_active ? <span className="px-2 py-0.5 rounded text-xs bg-slate-700 text-slate-300">Deactivated</span>
                        : expired ? <span className="px-2 py-0.5 rounded text-xs bg-red-500/15 text-red-300 border border-red-800">Expired</span>
                        : <span className="px-2 py-0.5 rounded text-xs bg-emerald-500/15 text-emerald-300 border border-emerald-800">Active</span>}
                    </td>
                    <td className="p-4 text-slate-300">{u.expiry_date ? new Date(u.expiry_date).toLocaleDateString() : "No limit"}</td>
                    <td className="p-4">
                      {dl === null ? "-" : (
                        <span className={dl <= 0 ? "text-red-400" : dl <= 7 ? "text-amber-400" : "text-emerald-400"}>{dl}</span>
                      )}
                    </td>
                    <td className="p-4">
                      <div className="flex gap-2 justify-end">
                        <button data-testid={`edit-user-${u.email}`} onClick={() => onEdit(u)}
                          className="px-3 py-1.5 rounded bg-blue-600/20 text-blue-300 hover:bg-blue-600/30 border border-blue-800 text-xs font-semibold">
                          Manage
                        </button>
                        <button data-testid={`delete-user-${u.email}`} onClick={() => onDelete(u.id)}
                          className="p-1.5 rounded bg-red-500/10 text-red-400 hover:bg-red-500/20 border border-red-900">
                          <Trash2 size={14} />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
